var React = require('react');

function IconAGroup (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M654.9 211s-15.9-18.4-44.6-18.4h-204s-23-5.1-50 37.2S67.1 755.5 67.1 755.5s-20.5 62.6 44.8 74.6H915s52.5-8.3 42.3-71.1c-27.6-48.5-154.2-272.1-154.2-272.1s-28.7-38-69.2-38c-40.6 0-179.2.4-179.2.4s-33.2-.4-25.7 34.8c15.9 32.3 22.8 43.4 22.8 43.4s6.3 8.4 20.6 8.4 141.4-.3 141.4-.3 21.2-.3 37.4 27.2 84.4 147.9 84.4 147.9 16.2 34.1-16.6 42.7l-615 1.1s-30.9-8.3-16.6-42c13.9-21.2 224.5-410.9 224.5-410.9s7.8-21.7 23.9-21.7c19 0 212.2-1.5 212.2-1.5s31.6-10 24-34.4-17.1-33-17.1-33z"}));
}

IconAGroup.displayName = "IconAGroup";

IconAGroup.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconAGroup;

IconAGroup.default = IconAGroup;
